import React from 'react';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const openModal =
  <C extends React.ElementType, P extends React.ComponentProps<C>>(
    component: C,
    props: P
  ) =>
  async (dispatch: any) => {
    await dispatch({
      type: OPEN_MODAL,
      payload: {
        component,
        props,
      },
    });
  };

export const closeModal =
  (key = '') =>
  async (dispatch: any) => {
    await dispatch({
      type: CLOSE_MODAL,
      payload: {
        key,
      },
    });
  };
